import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-black transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none border-4 border-black dark:border-white transform hover:rotate-1 duration-200 shadow-[6px_6px_0px_0px_#000000] dark:shadow-[6px_6px_0px_0px_#ffffff] hover:shadow-[2px_2px_0px_0px_#000000] dark:hover:shadow-[2px_2px_0px_0px_#ffffff] hover:translate-x-1 hover:translate-y-1",
  {
    variants: {
      variant: {
        default:
          "bg-[#1e74e6] text-white hover:bg-black dark:hover:bg-white hover:text-white dark:hover:text-black hover:rotate-0",
        destructive:
          "bg-red-500 text-white hover:bg-black dark:hover:bg-white hover:text-white dark:hover:text-black hover:rotate-0",
        outline:
          "bg-white dark:bg-gray-900 text-black dark:text-white hover:bg-[#60a5fa] hover:text-black dark:hover:text-white hover:rotate-0",
        secondary:
          "bg-[#17cbbf] text-black hover:bg-black dark:hover:bg-white hover:text-white dark:hover:text-black hover:rotate-0",
        ghost:
          "bg-transparent border-transparent text-black dark:text-white hover:bg-[#facc15] hover:text-black hover:border-black dark:hover:border-white",
        link: "bg-transparent border-transparent text-[#1e74e6] underline-offset-4 hover:underline hover:rotate-0",
      },
      size: {
        default: "h-10 px-6 py-3 has-[>svg]:px-4 text-base",
        sm: "h-8 px-4 py-2 has-[>svg]:px-3 text-sm",
        lg: "h-12 px-8 py-4 has-[>svg]:px-6 text-lg",
        icon: "size-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<"button"> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean
  }) {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  )
}

export { Button, buttonVariants }
